export default __webpack_public_path__ + "static/media/averageScoreImage.7afb69d0.png";